<template>
  <div
    class="upgrade-lock"
    @mouseover="showText()"
    @mouseleave="showHovertext = false"
    v-if="!isPhoneEnabled"
  >
    <div class="upgrade-icon d-flex">
      <Lock-Icon viewBox="100 -50 300 600" width="14px" height="14px" />
    </div>
    <div v-if="showHovertext">
      <span class="upgrade-pointer"></span>
      <div class="upgrade-body">
        <p class="upgrade-text">Upgrade to view {{ name }}</p>
        <div class="upgrade-cta">
          <button @click="upgrade">Start Free Trial</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sharedFunctions from '@/assets/util/functions.js'
import LockIcon from '@/assets/icons/svg/lockIcon.svg'
import { MxEvent } from '@/assets/util/constants/analytics.js'
import { BASE_URL_NEW } from '@/assets/util/constants/constants.js'
export default {
  name: 'Upgrade-Lock',
  props: ['type'],
  computed: {
    name: function () {
      return 'Direct Dials'
      //   switch (this.type) {
      //     case 'direct_line':
      //       return 'Direct Dials'
      //     case 'company_line':
      //       return 'Company Number'
      //     case 'mobile_number':
      //       return 'Mobile Number'
      //     default:
      //       return 'Other Number'
      //   }
    },
    isPhoneEnabled() {
      return this.$store.state.user.phoneNumberEnabled
    },
  },
  data: function () {
    return {
      showHovertext: false,
    }
  },
  components: {
    'Lock-Icon': LockIcon,
  },
  methods: {
    showText() {
      if (!this.showHovertext) {
        this.showHovertext = true
        this.fireMxOnHover()
      }
    },
    upgrade() {
      sharedFunctions.track(MxEvent.upgradeTooltip, null, this.$store.state)
      window.open(`${BASE_URL_NEW}/pricing`)
    },
    fireMxOnHover() {
      sharedFunctions.track(
        MxEvent.upgradeTooltipHovered,
        null,
        this.$store.state
      )
    },
  },
  created() {
    sharedFunctions.track(MxEvent.upgradeLockShown, null, this.$store.state)
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.upgrade-lock {
  position: relative;
  margin-left: 5px;
  .upgrade-icon {
    background: #fc9a01;
    border-radius: 50%;
    padding: 2px;
    svg {
      fill: $white !important;
    }
  }
  .upgrade-pointer {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #3c3c3c;
    position: absolute;
    bottom: -5px;
    left: 5px;
  }
  .upgrade-body {
    top: 23px;
    right: -55px;
    background: #3c3c3c;
    position: absolute;
    width: 140px;
    font-size: 12px;
    text-align: center;
    line-height: 17px;
    letter-spacing: 0.1px;
    padding: 15px;
    color: $white;
    border-radius: 3px;
    z-index: 1;
    .upgrade-text {
      margin: 0;
    }
    .upgrade-cta {
      margin-top: 10px;
      button {
        background: #fc9a01;
        border: 1px solid #fc9a01;
        padding: 3px 0;
        width: 100%;
        font-size: 12px;
        color: $white;
        font-weight: 400;
        letter-spacing: 0.3px;
        border-radius: 2px;
        &:hover {
          background: #dc8329;
          border: 1px solid #dc8329;
        }
      }
    }
  }
}
</style>
